import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getPatients } from '../../../../api/Patients';

export const usePatients = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();

  return useQuery(['patients', ...dependencies], () => getPatients(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 5000,
    ...options
  });
};
